import React from 'react';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import BreadCrumbOne from '../elements/breadcrumb/BreadCrumbOne';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import SEO from '../common/SEO';

const PrivacyPolicy = () => {
  return (
    <>
      <SEO title="Kebijakan Privasi" />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderOne />
        <BreadCrumbOne title="Kebijakan Privasi" page="Kebijakan Privasi" />
        <div className="section-padding privacy-policy-area">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="privacy-policy-content">
                  <div className="section-title">
                    <h5 className="title">Terakhir diperbarui: 8 Mei 2026</h5>
                  </div>

                  <p>
                    OOKEY Integrated System yang dioperasikan oleh PT Smart Integrasi Pratama ("kami", "OOKEY")
                    berkomitmen untuk melindungi privasi dan keamanan data pribadi Anda. Kebijakan Privasi ini
                    menjelaskan bagaimana kami mengumpulkan, menggunakan, menyimpan, dan melindungi informasi Anda
                    ketika menggunakan layanan kami.
                  </p>
                  <p>
                    Dengan menggunakan layanan OOKEY (EduOne, POS, Komuna, Smart Parking, dan produk lainnya),
                    Anda menyetujui praktik yang dijelaskan dalam kebijakan ini.
                  </p>

                  <h4>1. Informasi yang Kami Kumpulkan</h4>
                  <h5>1.1 Informasi yang Anda Berikan</h5>
                  <ul>
                    <li>Data registrasi: nama, email, nomor telepon, alamat institusi</li>
                    <li>Informasi institusi: nama sekolah/bisnis/organisasi, jenis institusi</li>
                    <li>Data pengguna sistem: username, password (terenkripsi), role/jabatan</li>
                    <li>Data transaksi dan pembayaran melalui platform kami</li>
                    <li>Komunikasi dengan tim support kami</li>
                  </ul>

                  <h5>1.2 Informasi yang Dikumpulkan Otomatis</h5>
                  <ul>
                    <li>Log aktivitas sistem dan penggunaan aplikasi</li>
                    <li>Alamat IP, browser, dan informasi perangkat</li>
                    <li>Data lokasi (untuk fitur tertentu seperti Smart Parking)</li>
                    <li>Cookies dan teknologi pelacakan serupa</li>
                  </ul>

                  <h5>1.3 Informasi dari Pihak Ketiga</h5>
                  <ul>
                    <li>Data dari payment gateway untuk proses pembayaran</li>
                    <li>Informasi dari API dan integrasi pihak ketiga yang Anda izinkan</li>
                  </ul>

                  <h4>2. Bagaimana Kami Menggunakan Informasi Anda</h4>
                  <p>Kami menggunakan informasi yang dikumpulkan untuk:</p>
                  <ul>
                    <li>Menyediakan dan mengoperasikan layanan OOKEY</li>
                    <li>Memproses transaksi dan pembayaran</li>
                    <li>Mengirimkan notifikasi terkait layanan (tagihan, pengumuman, update)</li>
                    <li>Memberikan dukungan pelanggan dan technical support</li>
                    <li>Meningkatkan dan mengembangkan produk kami</li>
                    <li>Melakukan analisis penggunaan untuk optimalisasi layanan</li>
                    <li>Mematuhi kewajiban hukum dan regulasi yang berlaku</li>
                    <li>Mencegah fraud dan aktivitas yang merugikan</li>
                  </ul>

                  <h4>3. Pembagian Informasi</h4>
                  <p>Kami TIDAK menjual data pribadi Anda kepada pihak ketiga. Kami hanya membagikan informasi dalam kondisi berikut:</p>
                  <ul>
                    <li><strong>Dengan persetujuan Anda:</strong> Ketika Anda memberikan izin eksplisit</li>
                    <li><strong>Penyedia layanan:</strong> Payment gateway, cloud hosting, dan vendor yang membantu operasional kami</li>
                    <li><strong>Kewajiban hukum:</strong> Jika diwajibkan oleh hukum atau proses hukum yang sah</li>
                    <li><strong>Perlindungan hak:</strong> Untuk melindungi hak, properti, atau keamanan OOKEY dan pengguna kami</li>
                  </ul>

                  <h4>4. Keamanan Data</h4>
                  <p>Kami menerapkan langkah-langkah keamanan teknis dan organisasi untuk melindungi data Anda:</p>
                  <ul>
                    <li>Enkripsi data (SSL/TLS) untuk transmisi data</li>
                    <li>Enkripsi password dengan algoritma hash yang aman</li>
                    <li>Firewall dan sistem keamanan jaringan</li>
                    <li>Akses terbatas berdasarkan role dan kebutuhan</li>
                    <li>Backup data berkala</li>
                    <li>Monitoring dan audit keamanan sistem</li>
                    <li>Pelatihan keamanan untuk tim internal</li>
                  </ul>
                  <p>
                    <em>
                      Meskipun kami berupaya maksimal, tidak ada sistem yang 100% aman. Kami mendorong Anda untuk
                      menjaga kerahasiaan password dan informasi akun Anda.
                    </em>
                  </p>

                  <h4>5. Hak Anda</h4>
                  <p>Sesuai dengan peraturan perlindungan data yang berlaku, Anda memiliki hak untuk:</p>
                  <ul>
                    <li><strong>Akses:</strong> Meminta salinan data pribadi yang kami miliki tentang Anda</li>
                    <li><strong>Koreksi:</strong> Memperbarui atau memperbaiki data yang tidak akurat</li>
                    <li><strong>Penghapusan:</strong> Meminta penghapusan data pribadi Anda (dengan batasan tertentu)</li>
                    <li><strong>Portabilitas:</strong> Menerima data Anda dalam format yang dapat dibaca mesin</li>
                    <li><strong>Keberatan:</strong> Menolak pemrosesan data pribadi untuk tujuan tertentu</li>
                    <li><strong>Penarikan persetujuan:</strong> Menarik persetujuan penggunaan data kapan saja</li>
                  </ul>
                  <p>
                    Untuk menggunakan hak-hak ini, silakan hubungi kami di{' '}
                    <a href="mailto:hello@ookey.id">hello@ookey.id</a>
                  </p>

                  <h4>6. Penyimpanan dan Retensi Data</h4>
                  <p>
                    Kami menyimpan data pribadi Anda selama akun Anda aktif atau sepanjang diperlukan untuk
                    menyediakan layanan. Data akan disimpan lebih lama jika diperlukan untuk:
                  </p>
                  <ul>
                    <li>Mematuhi kewajiban hukum dan perpajakan</li>
                    <li>Menyelesaikan sengketa</li>
                    <li>Menegakkan perjanjian kami</li>
                  </ul>
                  <p>Setelah periode retensi, data akan dihapus secara aman atau dianonimkan.</p>

                  <h4>7. Cookies dan Teknologi Pelacakan</h4>
                  <p>Kami menggunakan cookies dan teknologi serupa untuk meningkatkan pengalaman Anda. Cookies membantu kami:</p>
                  <ul>
                    <li>Mengingat preferensi dan pengaturan Anda</li>
                    <li>Memahami bagaimana Anda menggunakan layanan kami</li>
                    <li>Meningkatkan keamanan akun Anda</li>
                    <li>Menganalisis performa sistem</li>
                  </ul>
                  <p>Anda dapat mengatur browser untuk menolak cookies, namun beberapa fitur mungkin tidak berfungsi optimal.</p>

                  <h4>8. Privasi Anak-anak</h4>
                  <p>
                    Untuk produk OOKEY EduOne yang melibatkan data siswa, kami memproses data atas instruksi dan
                    dengan persetujuan dari institusi pendidikan (sekolah/yayasan) sebagai pengontrol data.
                    Institusi pendidikan bertanggung jawab untuk mendapatkan persetujuan dari orang tua/wali
                    untuk siswa di bawah umur sesuai regulasi yang berlaku.
                  </p>

                  <h4>9. Perubahan Kebijakan Privasi</h4>
                  <p>
                    Kami dapat memperbarui Kebijakan Privasi ini dari waktu ke waktu. Perubahan material akan
                    kami informasikan melalui email atau notifikasi di platform. Tanggal "Terakhir diperbarui"
                    di bagian atas menunjukkan versi terbaru. Penggunaan layanan setelah perubahan berarti
                    Anda menerima kebijakan yang diperbarui.
                  </p>

                  <h4>10. Hubungi Kami</h4>
                  <p>
                    Jika Anda memiliki pertanyaan, kekhawatiran, atau permintaan terkait Kebijakan Privasi ini
                    atau praktik data kami, silakan hubungi kami:
                  </p>
                  <p>
                    <strong>OOKEY Integrated System</strong><br />
                    PT Smart Integrasi Pratama<br />
                    Jl. Lawu, Karanganyar<br />
                    Email: <a href="mailto:hello@ookey.id">hello@ookey.id</a><br />
                    WhatsApp: <a href="https://wa.me/6283899669969">0838-9966-9969</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default PrivacyPolicy;
